import {
  EDIT_QUESTION_SURVEY,
  EDIT_SETTING_SURVEY,
  EXPORT_SURVEY,
  EXPORT_TEMPLATE_SURVEY,
  IMPORT_SURVEY,
} from "../events"
import { identifyUserSegment } from "../segmentTracks"
import {
  changeAttributesSurvey,
  changeAttributesQuestion,
} from "../attributesSegment"
import { LOCAL_USER_EMAIL } from "../../storage"

/**
 *
 * @param survey
 * @returns {string}
 */
export function getModelSurvey(survey) {
  if (survey.template_based) {
    return `Mandu ${getNameTypeSurvey(survey.id_survey_type)}`
  }
  if (!survey.template_based) {
    return "Personalizado"
  }
}

/**
 *
 * @param id
 * @returns {string}
 */
export function getNameTypeSurvey(id) {
  switch (id) {
    case 1:
      return "Clima Laboral"
      break
    case 2:
      return "Liderazgo"
      break
    default:
      return "No definido"
  }
}

/**
 *
 * @param status
 * @param info_survey
 * @param option
 * @param summary
 */
export const operationSurveySegment = (
  status,
  info_survey,
  option,
  summary
) => {
  switch (option) {
    case "exportTemplateSurvey":
      window.analytics.track(EXPORT_TEMPLATE_SURVEY, {
        data: identifyUserSegment(),
        email: LOCAL_USER_EMAIL(),
        tipo_cuestionario: info_survey,
        respuesta: status,
      })
      break
    case "importSurvey":
      window.analytics.track(IMPORT_SURVEY, {
        data: identifyUserSegment(),
        email: LOCAL_USER_EMAIL(),
        nombre_cuestionario: info_survey.name,
        ph_preguntas_importados: summary.count_import,
        ph_preguntas_sin_importar: summary.count_error,
        resumen: {
          preguntas_importados: summary.count_import,
          preguntas_sin_importar: summary.count_error,
        },
        numero_importaciones: summary.attempts,
        tipo_cuestionario: info_survey.survey_type,
        respuesta: status,
      })
      break
    case "exportSurvey":
      window.analytics.track(EXPORT_SURVEY, {
        data: identifyUserSegment(),
        email: LOCAL_USER_EMAIL(),
        nombre_cuestionario: info_survey.name,
        tipo_cuestionario: info_survey.survey_type,
        modelo_cuestionario: getModelSurvey(info_survey),
        respuesta: status,
      })
      break
  }
}

/**
 *
 * @param status
 * @param info_survey
 * @param infoEditQuestion
 */
export const editQuestionSegment = (infoEditQuestion, info_survey) => {
  /* window.analytics.track(EDIT_QUESTION_SURVEY, {
        data: identifyUserSegment(),
        nombre_cuestionario: info_survey.name,
        tipo_cuestionario: info_survey.survey_type,
        modelo_cuestionario: getModelSurvey(info_survey),
        campo_editado: changeAttributesQuestion(infoEditQuestion),
    }) */
}

/**
 *
 * @param status
 * @param info_survey
 * @param infoEditQuestion
 */
export const editSettingSegment = (editSetting, info_survey) => {
  window.analytics.track(EDIT_SETTING_SURVEY, {
    data: identifyUserSegment(),
    email: LOCAL_USER_EMAIL(),
    nombre_cuestionario: info_survey.name,
    tipo_cuestionario: info_survey.survey_type,
    modelo_cuestionario: getModelSurvey(info_survey),
    campo_editado: changeAttributesSurvey(editSetting, "normal"),
    ph_campo_editado: changeAttributesSurvey(editSetting, "planhat"),
  })
}
